/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.pos.create.description.controllers', [
  'acme.common.service.posConfig',
  'acme.common.directive.integer',
  'acme.common.service.validate'
])

.controller('PosCreateDescriptionController', ['$scope', 'PosConfigService', 'ValidateService', function($scope, PosConfigService, ValidateService) {

    $scope.posCreateDescription = {

      model: {
        description: '',
        orderListResultCountLimit: 50,
        apiTimeoutInSecs: 60,
        passcodes: [],
        cacheRefreshIntervalInSecs: 300,
        displayBrightnessPercent: 50
      },

      validators: [],

      allowMultiplePasscodes: false,

      init: function() {
        $scope.$on('PosCreateController::Save', this.onPosCreateSave);
        $scope.$on('PosCreateController::UpdateModel', this.onPosCreateUpdateModel);

        this.initView();
      },

      initView: function() {
        this.model = PosConfigService.options.getModel();

        if (!this.model.passcodes) {
          this.model.passcodes = [];
        }
        if (!this.model.orderListResultCountLimit) {
          this.model.orderListResultCountLimit = 50;
        }

        if (!this.model.apiTimeoutInSecs) {
          if(this.model.apiTimeoutInSecs === 0) {
            this.model.apiTimeoutInSecs = 0;
          } else {
            this.model.apiTimeoutInSecs = 60;
          }
        }

        if (!this.model.cacheRefreshIntervalInSecs) {
          if(this.model.cacheRefreshIntervalInSecs === 0) {
            this.model.cacheRefreshIntervalInSecs = 0;
          } else {
            this.model.cacheRefreshIntervalInSecs = 300;
          }
        }

        if (!this.model.displayBrightnessPercent) {
          if(this.model.displayBrightnessPercent === 0) {
            this.model.displayBrightnessPercent = 0;
          } else {
            this.model.displayBrightnessPercent = 50;
          }
        }


        this.initValidators();
      },

      initValidators: function() {
        this.validators = [
          {
            field: 'pos-create-description-order',
            number: {
              message: 'Order results limit must be a number',
              test: function() {
                var self = $scope.posCreateDescription;
                return self.model.orderListResultCountLimit;
              }
            }
          },
          {
            field: 'pos-create-description-order',
            less: {
              message: 'The order result limit is too large',
              test: function() {
                var self = $scope.posCreateDescription, greater = (self.model.orderListResultCountLimit + '').length;

                return {
                  greater: greater,
                  less: 9
                };
              }
            }
          },
          {
            field: 'pos-create-description-order',
            greater: {
              message: 'Please enter valid number of order results',
              test: function() {
                var self = $scope.posCreateDescription, greater = self.model.orderListResultCountLimit;

                return {
                  greater: greater,
                  less: 0
                };
              }
            }
          },
          {
            field: 'pos-create-description-api',
            number: {
              message: 'The API timeout must be a number',
              test: function() {
                var self = $scope.posCreateDescription;
                return self.model.apiTimeoutInSecs;
              }
            }
          },
          {
            field: 'pos-create-description-api',
            len: {
              message: 'The API timeout must not be empty',
              test: function() {
                var self = $scope.posCreateDescription;
                return {
                  value: self.model.apiTimeoutInSecs + ''
                };
              }
            }
          },
          {
            field: 'pos-create-description-api',
             positive: {
               message: 'The API timeout must be greater than 0',
               test: function() {
                 var self = $scope.posCreateDescription;
                 return self.model.apiTimeoutInSecs;
               }
              }
            },
          {
            field: 'pos-create-description-api',
            less: {
              message: 'Your api timeout is too large',
              test: function() {
                var self = $scope.posCreateDescription, greater = (self.model.apiTimeoutInSecs + '').length;

                return {
                  greater: greater,
                  less: 5
                };
              }
            }
          },
          {
            field: 'pos-create-description-cache',
            number: {
              message: 'The cache refresh interval must be a number',
              test: function() {
                var self = $scope.posCreateDescription;
                return self.model.cacheRefreshIntervalInSecs;
              }
            }
          },
          {
            field: 'pos-create-description-cache',
            len: {
              message: 'The cache refresh interval must not be empty',
              test: function() {
                var self = $scope.posCreateDescription;
                return {
                  value: self.model.cacheRefreshIntervalInSecs + ''
                };
              }
            }
          },
          {
            field: 'pos-create-description-cache',
            greater: {
              message: 'The cache refresh interval must be 0 or greater.',
              test: function() {
                var self = $scope.posCreateDescription, greater = (self.model.cacheRefreshIntervalInSecs);

                return {
                  less: 0,
                  greater: greater,
                  equalTo: true
                };
              }
            }
          },
          {
            field: 'pos-create-description-cache',
            less: {
              message: 'Your cache refresh interval must be 86400 seconds (1 day) or less.',
              test: function() {
                var self = $scope.posCreateDescription, greater = self.model.cacheRefreshIntervalInSecs;

                return {
                  greater: greater,
                  less: 86400,
                  equalTo: true
                };
              }
            }
          },
          {
            field: 'pos-create-description-brightness',
            number: {
              message: 'The display brightness percentage must be a number',
              test: function() {
                var self = $scope.posCreateDescription;
                return self.model.displayBrightnessPercent;
              }
            }
          },
          {
            field: 'pos-create-description-brightness',
            len: {
              message: 'The display brightness percentage must not be empty',
              test: function() {
                var self = $scope.posCreateDescription;
                return {
                  value: self.model.displayBrightnessPercent + ''
                };
              }
            }
          },
          {
            field: 'pos-create-description-brightness',
            greater: {
              message: 'The display brightness percentage must be 0 or greater.',
              test: function() {
                var self = $scope.posCreateDescription, greater = (self.model.displayBrightnessPercent);

                return {
                  less: 0,
                  greater: greater,
                  equalTo: true
                };
              }
            }
          },
          {
            field: 'pos-create-description-brightness',
            less: {
              message: 'Your display brightness percentage cannot be more than 100.',
              test: function() {
                var self = $scope.posCreateDescription, greater = (self.model.displayBrightnessPercent);

                return {
                  greater: greater,
                  less: 100,
                  equalTo: true
                };
              }
            }
          },
          {
            field: 'pos-create-description-passcodes',
            number: {
              message: 'Your passcode must be a number',
              test: function() {
                var self = $scope.posCreateDescription,
                  passcodes = self.model.passcodes.map(function(passcode) {
                    return passcode.code || '';
                  });
                return passcodes.length ? passcodes.join('') : 0;
              }
            }
          },
          {
            field: 'pos-create-description-passcodes',
            less: {
              message: 'Your passcode is too long',
              test: function() {
                var self = $scope.posCreateDescription,
                  passcodes = self.model.passcodes.map(function(passcode) {
                    return passcode.code || '';
                  }),
                  greater = (passcodes.join('')).length;

                return {
                  greater: greater,
                  less: (self.model.passcodes.length)*6 + 1
                };
              }
            }
          }
        ];
      },

      getError: function(field) {
        return ValidateService.getError(field);
      },

      addPasscode: function () {
        if (!PosConfigService.options.hasPasscodes()) {
          this.model.passcodes = [];
        }
        this.model.passcodes.push(PosConfigService.options.newPasscode({
          type: "refund",
          length: 0,
          code: ""
        }));
      },

      checkPasscode: function(passcode) {
        var r = true;
        if (passcode) {
          r = (ValidateService.validators.number(passcode)) && (passcode+'').length <= 6;
        }
        return r;
      },

      removePasscode: function(index) {
        this.model.passcodes.splice(index, 1);
      },

      checkDisplayBrightness: function() {
        var percent = parseFloat(this.model.displayBrightnessPercent);

        if (!isNaN(percent)) {
          this.model.displayBrightnessPercent = percent;
        }else{
          this.model.displayBrightnessPercent = 0;
        }
      },

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      },

      onPosCreateSave: function(e, data) {
        var self = $scope.posCreateDescription;

        PosConfigService.options.setModel(self.model);
        ValidateService.validate(self.validators);
      },

      onPosCreateUpdateModel: function(e, data) {
        var self = $scope.posCreateDescription;
        PosConfigService.options.setModel(PosConfigService.options.getModel());
        self.initView();
      }

    };

    $scope.posCreateDescription.init();

}]);